import { API } from '@/utils/api'

export const userSelectColumnsMixin = {
  data () {
    return {
      selectedColumns: [],
    }
  },
  computed: {
    selectedHeaders () {
      return (headers) => headers.filter(({ value }) => this.selectedColumns.includes(value))
    }
  },
  methods: {
    loadTableColums: async function (type) {
      const defaultColumns = this.headers.filter(r => !r.defaultHide).map(({ value }) => value)
      this.selectedColumns = this.$store.state.auth?.user?.settings?.payment_handler_options?.[type] ?? defaultColumns
    },
    setTableColumns: async function (columns, type) {
      const tableColumns = await API.call('/$v/payment_handler/set_user_columns.json', {
        user_columns: columns,
        type,
      }, null, this.project)
      return tableColumns
    },
    setSelectedColumns: function (columns, type) {
      this.selectedColumns = columns
      this.setTableColumns(this.selectedColumns, type)
    },
  }
}
